import HotelProfileStateHook from '@/hooks/useHotelProfileState';
import { Typography } from 'antd';
import { HtmlText } from "@/components/HtmlText";

export default function HotelIntro() {
  const { dataSource } = HotelProfileStateHook()
  const { hotelIntro } = dataSource || {}
  return (
    <div style={{ padding: '12px 4px' }}>
      <Typography.Title level={3} style={{ marginTop: 8, marginBottom: 8 }}>{hotelIntro?.title}</Typography.Title>
      <Typography.Paragraph type="secondary" style={{ marginBottom: 12 }}>
        <HtmlText value={hotelIntro?.content} />
      </Typography.Paragraph>
    </div>
  );
}
